import { HttpError } from './HttpError.js';
/**
 * Custom error class for handling failed HTTP requests.
 * Provides access to the original Response object and commonly needed properties.
 */
export class FetchError extends HttpError {
    response;
    /** The URL that was requested */
    url;
    /**
     * Creates a new FetchError instance
     *
     * @param response - The Response object from the failed request
     * @param message - Optional error message (defaults to response.statusText)
     */
    constructor(
    /** The original Response object */
    response, message) {
        super(response.status, message || response.statusText);
        this.response = response;
        this.url = response.url;
        this.name = 'FetchError';
    }
}
//# sourceMappingURL=FetchError.js.map